import { Checkbox, FormControlLabel } from '@mui/material';
import { useEffect, useState } from 'react';

import {
    DescriptivePersonalizationSettingsConfig,
    OthersPersonalizationSettingsConfig,
    StylePersonalizationSettingsConfig,
    BrandPersonalizationSettingsConfig,
    ShapePersonalizationSettingsConfig,
    VisionCarePersonalizationSettingsConfig,
    WhoPersonalizationSettingsConfig,
} from '@utils/pages-utils/MyProfileUtils';

import { getLabelFallback } from '@utils/utils';

import { useFormContext } from 'react-hook-form';

type SettingsSectionType = 'brand' | 'shape' | 'visionCare' | 'who' | 'style' | 'descriptive' | 'others';

interface Props {
    settingsSectionTitle: string;
    settingsSectionType: SettingsSectionType;
    settingsSettingsConfig:
    | StylePersonalizationSettingsConfig
    | DescriptivePersonalizationSettingsConfig
    | OthersPersonalizationSettingsConfig
    | BrandPersonalizationSettingsConfig
    | ShapePersonalizationSettingsConfig
    | VisionCarePersonalizationSettingsConfig
    | WhoPersonalizationSettingsConfig;
}

const TypesPersonalizationSettings = ({
    settingsSectionTitle,
    settingsSectionType,
    settingsSettingsConfig,
}: Props): JSX.Element => {


    const [maxReached, setMaxReached] = useState(false);
    const [numSelected, setNumSelected] = useState(0);
    const [isChecked, setIsChecked] = useState(false)
    const [checkBoxes, setcheckBoxes] = useState(() => {
        let checkBoxesDict = {}
        Object.keys(settingsSettingsConfig).map(setting => {

            checkBoxesDict[setting] = settingsSettingsConfig[setting].value;
            if (settingsSettingsConfig[setting].value === true) {
                setNumSelected((numSelected) => numSelected + 1);
            }

        })
        return checkBoxesDict;
    });

    useEffect(() => {
        if (numSelected >= 3) {
            setMaxReached(true);
        }

        if (numSelected < 3) {
            setMaxReached(false);
        }
    }, [numSelected]);

    const methods = useFormContext();


    const handleChange = function (e) {
        checkBoxes[e.target.name] = e.target.checked;
		settingsSettingsConfig[e.target.name].value = e.target.checked;
        if (e.target.checked) {
            setNumSelected((numSelected) => numSelected + 1);
        }
        if (!e.target.checked && numSelected > 0) {
            setNumSelected((numSelected) => numSelected - 1);
        }
    }

    return (
        <div className={`personalization-settings_${settingsSectionType}`}>
            <div className="personalization-settings_title">
                <span className="secondary-message large bold align-left personalization-setting">
                    {getLabelFallback(settingsSectionTitle)}&nbsp;
                </span>
               
                <span>{getLabelFallback('MAX_ANSWER_LABEL')}</span>
            </div>
            <div className={`${settingsSectionType}-settings-container`}>
                {

                    Object.keys(settingsSettingsConfig).map(setting => (
                        <FormControlLabel
                            data-analytics_available_call="0"
                            {...methods.register(setting)}
                            key={setting}
                            className={`${settingsSectionType}-setting ${setting}`}
                            classes={{ label: 'primary-message medium' }}
                            control={
                                <Checkbox
                                    size="small"
                                    defaultChecked={settingsSettingsConfig[setting].value}
                                    onChange={handleChange}
                                    disabled={maxReached && !checkBoxes[setting]}
                                />
                            }
                            label={getLabelFallback(settingsSettingsConfig[setting].label)}
                        />
                    ))}
            </div>
        </div>
    );
};

export default TypesPersonalizationSettings;
